export default {
  state: {
    newRecommendations: null,
  },
  getters: {
    NewRecommendations: s => s.newRecommendations,
  },
  mutations: {
    updateNewRecommendations(s, newRecommendations) {
      s.newRecommendations = newRecommendations
    },
  },
  actions: {
    async fetchNewRecommendations(ctx, {url, without_rec_cards='false', max_cards=4}) {
      return this.$axios({
        method: 'GET',
        url: `/api/content/recommendations/short/?url=${url}&without_rec_cards=${without_rec_cards}&max_cards=${max_cards}`,
      })
        .then((response) => {
          const status = response.data.status;
          if (status >= 400) {
            return false
          }
          ctx.commit('updateNewRecommendations', response.data)
          return true
        })
        .catch((error) => {
          ctx.commit('updateRecommendations', null)
          return false
        });
    },
  },
}
